/** Small readers of ProgramRules shared by the builder, the site and the cabinet. */
import type { ProgramRules } from "@prop/contracts";

type ProfitableDays = NonNullable<NonNullable<ProgramRules["payouts"]>["profitableDays"]>;

/** "0.5 %" and / or "$150" — the bar of a profitable day as the rules state it (ADR-0031). */
export const dayBar = (pd: ProfitableDays): string => [pd.minProfitPct && `${pd.minProfitPct} %`, pd.minProfit && `$${pd.minProfit}`].filter(Boolean).join(" / ");
